import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { TwoFactorFormType } from 'data/types'
import { call, put } from 'redux-saga/effects'
import { refreshBackupCodes } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import { displayCodesWorker } from './displayCodesStep'

export default function* generateNewCodesStep(form: TwoFactorFormType) {
  const data: Response<void> = yield call(refreshBackupCodes, form)

  if (!data.ok) {
    yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield call(displayCodesWorker, form)
}
